import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

interface ISendVideoStatsLinksReportParams {
  videoId: number;
  recipients: string[];
}

const sendVideoStatsLinksReport = async (
  params: ISendVideoStatsLinksReportParams
) => {
  return (
    await EXPRESS_API.post(`/videos/${params.videoId}/links/send`, {
      recipients: params.recipients,
    })
  ).data;
};

interface ISendVideoStatsLinks {
  onSuccess?: () => void;
}

export const useSendVideoStatsLinksReport = ({
  onSuccess,
}: ISendVideoStatsLinks) => {
  const { showError } = useToastError();
  const { t } = useTranslation();
  return useMutation(
    (data: ISendVideoStatsLinksReportParams) => sendVideoStatsLinksReport(data),
    {
      onError: () => {
        showError(
          t(
            'An error occurred while trying to send the report. Please try again.'
          )
        );
      },
      onSuccess: () => {
        successToast({
          title: 'CTA Clicks report has been successfully sent.',
        });
        if (onSuccess) onSuccess();
      },
    }
  );
};
